import {
  FETCH_CATEGORIES_REQUEST,
  FETCH_CATEGORIES_SUCCESS,
  FETCH_CATEGORIES_FAILURE,
  ADD_CATEGORY_REQUEST,
  ADD_CATEGORY_SUCCESS,
  ADD_CATEGORY_FAILURE,
  UPDATE_CATEGORY_REQUEST,
  UPDATE_CATEGORY_SUCCESS,
  UPDATE_CATEGORY_FAILURE,
  DELETE_CATEGORY_REQUEST,
  DELETE_CATEGORY_SUCCESS,
  DELETE_CATEGORY_FAILURE,
  SET_CATEGORY_EDIT,
  CLEAR_CATEGORY_EDIT,
} from '../../../../types/masters/styles/category/categoryTypes';
import {
  fetchCategories,
  addCategory,
  updateCategory,
  deleteCategory,
} from '../../../../../api/masters/styles/category/categoryApi';

export const fetchCategoriesAction = () => async (dispatch) => {
  dispatch({ type: FETCH_CATEGORIES_REQUEST });
  try {
    const data = await fetchCategories();
    dispatch({ type: FETCH_CATEGORIES_SUCCESS, payload: data });
  } catch (error) {
    dispatch({ type: FETCH_CATEGORIES_FAILURE, payload: error.message });
  }
};

export const addCategoryAction = (category) => async (dispatch) => {
  dispatch({ type: ADD_CATEGORY_REQUEST });
  try {
    await addCategory(category);
    dispatch({ type: ADD_CATEGORY_SUCCESS });
    dispatch(fetchCategoriesAction());
  } catch (error) {
    dispatch({ type: ADD_CATEGORY_FAILURE, payload: error.message });
    throw error;
  }
};

export const updateCategoryAction = ({ id, category }) => async (dispatch) => {
  dispatch({ type: UPDATE_CATEGORY_REQUEST });
  try {
    const data = await updateCategory(id, category);
    dispatch({ type: UPDATE_CATEGORY_SUCCESS, payload: data });
    dispatch(fetchCategoriesAction());
  } catch (error) {
    dispatch({ type: UPDATE_CATEGORY_FAILURE, payload: error.message });
    throw error;
  }
};

export const deleteCategoryAction = (id) => async (dispatch) => {
  dispatch({ type: DELETE_CATEGORY_REQUEST });
  try {
    await deleteCategory(id);
    dispatch({ type: DELETE_CATEGORY_SUCCESS });
    dispatch(fetchCategoriesAction());
  } catch (error) {
    dispatch({ type: DELETE_CATEGORY_FAILURE, payload: error.message });
    throw error;
  }
};

export const setCategoryEdit = (category) => ({
  type: SET_CATEGORY_EDIT,
  payload: category,
});

export const clearCategoryEdit = () => ({
  type: CLEAR_CATEGORY_EDIT,
}); 